export function variableNameFromLabel(label: string): string {
  return label
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_]/g, '');
}

export function hasVariableName(name: string): boolean {
  return /[a-z0-9]/.test(name);
}
